// The destinations of the main navigation: five items on phones (design direction, "Phone principles"),
// five in the top navigation at the desk. Every item has a screen and is a link; an item without "to" would be
// shown as "folgt" and is never a link. Giving it a route is the whole change when its screen arrives. "Mehr"
// exists on phones only, "Einstellungen" at the desk only, so both bars keep five reachable destinations.

import type { ToOptions } from "@tanstack/react-router";
import type { GlyphName } from "../../components/Glyph";
import type { MessageId } from "../../lib/i18n";

export interface NavItem {
  id: "heute" | "vergleiche" | "kosten" | "eingang" | "mehr" | "einstellungen";
  glyph: GlyphName;
  /** Label in the bottom bar. */
  label: MessageId;
  /** Label in the top navigation, when it differs from the bottom bar. */
  deskLabel?: MessageId;
  /** Route of the screen. Absent while the screen does not exist. */
  to?: ToOptions["to"];
  /** False for items that exist on phones only. */
  desk: boolean;
  /** False for items that exist at the desk only. */
  phone: boolean;
}

export const navItems: readonly NavItem[] = [
  { id: "heute", glyph: "home", label: "nav.heute", to: "/", desk: true, phone: true },
  { id: "vergleiche", glyph: "queue", label: "nav.vergleiche", to: "/vergleiche", desk: true, phone: true },
  {
    id: "kosten",
    glyph: "ledger",
    label: "nav.kosten",
    deskLabel: "nav.kostenwaechter",
    to: "/kosten",
    desk: true,
    phone: true,
  },
  { id: "eingang", glyph: "inbox", label: "nav.eingang", to: "/eingang", desk: true, phone: true },
  { id: "mehr", glyph: "menu", label: "nav.mehr", to: "/mehr", desk: false, phone: true },
  { id: "einstellungen", glyph: "more", label: "nav.einstellungen", to: "/einstellungen", desk: true, phone: false },
];
